<template>
  <div class="grid grid-cols-6 gap-6">
    <div class="col-span-6">
      <FormInput
        id="companyName"
        type="text"
        :value="companyStore.company.name"
        :label="t('company.name') + '*'"
        :onInput="updateName"
        :rules="nameRules"
      />
    </div>
    <div class="col-span-6">
      <FormInput
        id="companySlug"
        type="text"
        :value="companyStore.company.slug"
        :label="t('company.slug')"
        :onInput="updateSlug"
        :rules="slugRules"
      />
    </div>
    <div class="col-span-6">
      <FormInput
        id="companyWebsiteUrl"
        type="text"
        :value="companyStore.company.websiteUrl"
        :label="t('company.websiteUrl')"
        :onInput="updateWebsiteUrl"
        :rules="websiteUrlRules"
      />
    </div>
    <div class="col-span-6">
      <FormInput
        id="companyEmail"
        type="email"
        :value="companyStore.company.email"
        :label="t('company.email')"
        :onInput="updateEmail"
        :rules="emailRules"
      />
    </div>
    <div class="col-span-6">
      <FormInput
        id="companyphone"
        type="text"
        :value="companyStore.company.phone"
        :label="t('company.phone')"
        :onInput="updatePhone"
        :rules="phoneRules"
      />
    </div>
    <div class="col-span-6">
      <label
        class="mb-1 flex items-center gap-x-1 text-sm font-medium text-gray-700"
      >
        {{ t('company.staffingAgency') }}
        <HelpPopover :text="t('company.staffingAgencyPopover')" />
      </label>
      <Toggle
        :srLabel="t('company.staffingAgency')"
        :checked="companyStore.company.staffingAgency"
        :onToggle="onToggle"
        :disabled="companyStore.company.id !== 'new'"
      />
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { useCompanyStore } from '../../store/companyStore'
import { required, helpers, url, email } from '@vuelidate/validators'
import FormInput from '../FormInput.vue'
import toKebabCase from 'lodash.kebabcase'
import Toggle from '../Toggle.vue'
import HelpPopover from '../HelpPopover.vue'

const companyStore = useCompanyStore()

const { t } = useI18n({
  inheritLocale: true,
  useScope: 'global',
})

const nameRules = {
  required: helpers.withMessage(
    t('validations.companyName.required'),
    required,
  ),
  $autoDirty: true,
}

const updateName = (newValue) => {
  companyStore.company.slug = toKebabCase(newValue)
  companyStore.company.name = newValue
}

const slugRules = {
  $autoDirty: true,
}

const updateSlug = (newValue) => {
  companyStore.company.slug = newValue
}

const websiteUrlRules = {
  url: helpers.withMessage(t('validations.companyWebsiteUrl.url'), url),
  $autoDirty: true,
}

const updateWebsiteUrl = (newValue) => {
  companyStore.company.websiteUrl = newValue
}

const emailRules = {
  email: helpers.withMessage(t('validations.companyEmail.email'), email),
  $autoDirty: true,
}

const updateEmail = (newValue) => {
  companyStore.company.email = newValue
}

const phoneRules = {
  $autoDirty: true,
}

const updatePhone = (newValue) => {
  companyStore.company.phone = newValue
}

const onToggle = () => {
  companyStore.company.staffingAgency = !companyStore.company.staffingAgency
}
</script>
